import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import colors from 'common/styles/colors';

import styles from './index.module.css';

const Typography = ({
  tag,
  size,
  color,
  weight,
  children,
  className,
  ...props
}) => {
  const Tag = tag;
  const sizeClass = size ? styles[`text-${size}`] : null;
  const weightClass = weight ? styles[weight] : null;
  const rootStyles = classNames(styles.root, sizeClass, weightClass, className);

  return (
    <Tag className={rootStyles} style={{ color: colors[color] }} {...props}>
      {children}
    </Tag>
  );
};

Typography.propTypes = {
  tag: PropTypes.oneOf([
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'p',
    'span',
    'div',
  ]),
  size: PropTypes.oneOf(['xs', 'sm', 'base', 'md', 'lg', 'xl', '2xl']),
  color: PropTypes.oneOf(Object.keys(colors)),
  weight: PropTypes.oneOf(['regular', 'medium', 'semiBold']),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

Typography.defaultProps = {
  tag: 'p',
  size: 'base',
  color: 'rebranding-md-color-brand-black',
  weight: 'regular',
  className: null,
};

export default Typography;
